<template>
  <div class="worksDetails">
    <div class="worksDetails_box">
      <div class="worksDetails_box_nap">
        <p>当前位置：</p>
        <!-- <p>设计市场</p>
        <i class="el-icon-arrow-right"></i>
        <p>作品详情</p> -->
		<el-breadcrumb separator=">">
		  <el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
		  <el-breadcrumb-item >作品详情</el-breadcrumb-item>
		</el-breadcrumb>
      </div>
      <div class="box_mess"> 
        <div class="box_mess_left">
          <h3 class="">缤纷多彩的桌灯集锦--3D打印</h3>
          <p class="mess_left_mess">作品简介</p>
          <div class="mess_left_die">
            <p class="mess_left_dieL">作品类型：3D模型</p>
            <div class="mess_left_dieR">
              <p>
                <i class="iconfont">&#xe611;</i>
                <span>1.4w</span>
              </p>
              <i class="iconfontGnag"> | </i>
               <p>
                <i class="iconfont iconfont2">&#xe639;</i>
                <span>1.4w</span>
              </p>
              <i class="iconfontGnag"> | </i>
               <p>
                <i class="iconfont">&#xe60d;</i>
                <span>1.4w</span>
              </p>
            </div>
          </div>
        </div>
        <div class="box_mess_right">
          <img src="" alt="">
          <div class="mess_right_btn">
            <p>王静</p>
            <button>私信</button>
          </div>
        </div>
      </div>
      <div class="box_content">
        <p>作品说明：作品说明作品说明作品说明作品说明作品说明
          作品说明作品说明作品说明作品说明作品说明作品说明作品
          说明作品说明作品说明作品说明作品说明作品说明作品说明
          作品说明作品说明作品说明作品说明作品说明作品说明作品
          说明作品说明作品说明作品说明作品说明作品说明作品说明
          作品说明作品说明作品说明作品说明作品说明作品说明作品
          说明作品说明作品说明作品说明作品说明作品说明作品说明
          作品说明作品说明作品说明作品说明作品说明作品说明作品
          说明作品说明作品说明作品说明作品说明作品说明作品说明
          作品说明作品说明作品说明</p>
          <div class="box_button">
            <button>
              <i class="el-icon-message"></i>
              <p>投票</p>
              <p class="box_button_num">11234</p>
            </button>
          </div>

      </div>
      <div class="box_evaluate">
        <div class="box_evaluate_send">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="textarea">
          </el-input>
          <div class="evaluate_send">
            <button>评价</button>
          </div>
        </div>
        <div class="evaluate_list">
          <p class="evaluate_list_title">全部评价</p>
          <div class="evaluate_list_mess">
            <img src="" alt="">
            <div class="evaluate_list_content">
              <p class="evaluate_list_content_top">
                <span>跟我学个P（PPT）</span>
                <span class="top_span">2021年8月9日</span>
              </p>
              <p>商家的服务很周到，解决了我所有的问题，而且设计师工作的效率还很高只用了一点点额时间就完成了！</p>
            </div>
          </div>
          <div class="evaluate_list_mess">
            <img src="" alt="">
            <div class="evaluate_list_content">
              <p class="evaluate_list_content_top">
                <span>跟我学个P（PPT）</span>
                <span class="top_span">2021年8月9日</span>
              </p>
              <p>商家的服务很周到，解决了我所有的问题，而且设计师工作的效率还很高只用了一点点额时间就完成了！</p>
            </div>
          </div>
          <div class="evaluate_list_mess">
            <img src="" alt="">
            <div class="evaluate_list_content">
              <p class="evaluate_list_content_top">
                <span>跟我学个P（PPT）</span>
                <span class="top_span">2021年8月9日</span>
              </p>
              <p>商家的服务很周到，解决了我所有的问题，而且设计师工作的效率还很高只用了一点点额时间就完成了！</p>
            </div>
          </div>
        </div>
        <div class="evaluate_no">
          没有更多评论了!
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "worksDetails",
  data() {
    return {
      textarea:'',
    };
  },
  components: {
  },
  mounted(){
  },
  methods: {
  },
};
</script>

<style scoped lang="less">
.worksDetails {
  background: rgba(249, 249, 249);
  padding-bottom: 60px;
  .worksDetails_box {
    width: 1200px;
    margin: 0 auto;
    .worksDetails_box_nap {
      font-size: 14px;
      color: #808080;
      padding: 20px 0;
      display: flex;
      align-items: center;
      i {
        margin: 0 5px;
      }
    }
    .box_mess {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .box_mess_left {
        width: 956px;
        height: 132px;
        background: rgba(255, 255, 255);
        border-radius: 10px;  
        flex-shrink: 0;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 23px 24px 23px 22px;
        h3 {
          font-size: 18px;
          color: #414141;
        }
        .mess_left_mess {
          font-size: 12px;
          color: #7D848E;
          margin: 4px 0 20px;
        }
        .mess_left_die {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .mess_left_dieL {
            font-size: 14px;
            color: #099;
          }
          .mess_left_dieR {
            display: flex;
            align-items: center;
            p {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #A9AFB8;
              .iconfont {
                margin-top: 3px;
                margin-right: 2px;
              }
              .iconfont2 {
                margin-top: 0;
              }
            }
            .iconfontGnag {
              font-style: normal;
              color: #A9AFB8;
              margin: 0 15px;
              font-size: 10px;
            }
          }
        }
      }
      .box_mess_right {
        width: 234px;
        height: 132px;
        background: rgba(255, 255, 255);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          margin-right: 22px;
        }
        .mess_right_btn {
          p {
            margin-bottom: 9px;
            font-size: 18px;
            color: #414141;
          }
          button {
            width: 70px;
            height: 24px;
            border: 1px solid #099;
            border-radius: 4px;
            font-size: 12px;
            color: #099;
            background: transparent;
            cursor: pointer;
          }

        }
      }

    }
    .box_content {
      background: rgba(255, 255, 255);
      border-radius: 10px;
      box-sizing: border-box;
      padding: 18px 22px 20px;
      margin-bottom: 10px;
      img {
        max-width: 100%;
      }
      .box_button {
        margin-top: 26px;
        text-align: center;
        button {
          width: 140px;
          height: 80px;
          background: rgba(21, 126, 251);
          box-shadow: 0px 3px 6px rgba(21, 126, 251, 0.3);
          border-radius: 50px;
          color: #fff;
          font-size: 12px;
          i {
            font-size: 14px;
          }
          .box_button_num {
            font-size: 18px;
            margin-top: 3px;
          }          
        }


      }
    }
    .box_evaluate {
      background: rgba(255, 255, 255);
      border-radius: 10px;
      .box_evaluate_send {
        border-bottom: 2px solid #a9aeb785;
        padding: 10px 12px 20px;
        .evaluate_send {
          margin-top: 20px;
          text-align: right;
          button {
            width: 70px;
            height: 24px;
            border: 1px solid #ABABAB;
            border-radius: 4px;
            font-size: 12px;
            color: #ABABAB;
            background: transparent;
          }          
        }
        /deep/.el-textarea__inner {
          height: 63px;
          background: rgba(246, 246, 246);
          border-radius: 10px;
          font-size: 14px;
          border: none;
        }

      }
      .evaluate_list {
        padding: 8px 16px;
        .evaluate_list_title {
          font-size: 16px;
          color: #5C5F5C;
          margin-bottom: 14px;
        }
        .evaluate_list_mess {
          display: flex;
          padding-bottom: 18px;
          border-bottom: 1px solid #ECECEC;
          margin-bottom: 20px;
          &:nth-last-of-type(1){
            border-bottom: none;
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 20px;
          }
          .evaluate_list_content {
            font-size: 14px;
            color: #262626;
            width: 100%;
            .evaluate_list_content_top {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 8px;
              .top_span {
                font-size: 10px;
                color: #B8B8B8;
              }
            }

          }
        }
      }
      .evaluate_no {
        font-size: 14px;
        color: #5C5F5C;
        border-top: 1px solid #ECECEC;
        text-align: center;
        height: 37px;
        line-height: 37px;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/winDetails.vue